import { OfferResponse } from '../../../infrastructure/response/offer/offer.response';
import { MassActionItemInterface } from '../../../domain/models/mass-action-item.interface';
import { Warehouse } from '../../../domain/entity/warehouse/warehouse.entity';
import { Offer } from '../../../domain/entity/offer/offer.entity';

export class OfferFacade implements MassActionItemInterface
{
    private constructor(private _offer: Offer)
    {}

    get id(): string
    {
        return this.offer.id;
    }

    get offer(): Offer
    {
        return this._offer;
    }

    get freezeTime(): Date | null
    {
        return this.offer.freezeTime;
    }

    get fullName(): string {
        return [this.offer.brand, this.offer.partNumber, this.offer.name].filter((x) => Boolean(x)).join(', ');
    }

    static build = (offer: OfferResponse, warehouse: Warehouse): OfferFacade => new OfferFacade(
        Offer.build(offer, warehouse),
    );
}
